import React from "react";
import { languages } from "../../constants/languages";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectPoules = props => (
  <Autocomplete
    disabled={props.tournament.scheduleLocked || false}
    groupBy={option => option.labelDivision || ""}
    size="small"
    multiple
    disableCloseOnSelect
    options={props.options}
    getOptionLabel={option => option.labelLong || option.label}
    // getOptionSelected={option => {
    //   return props.value.find(v => option.id === v.id) ? true : false;
    // }}
    onChange={(e, newValue) => {
      props.handleSelectChange(e, newValue);
    }}
    value={props.selectedValue}
    renderOption={(option, { selected }) => {
      let isSelected = selected;
      if (option.value === "all") {
        isSelected = props.selectedValue.find(v => v.value === "all")
          ? true
          : false;
      }
      let label = option.label;
      if (option.value === "all") {
        label = <b>{option.label}</b>;
      }
      return (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={isSelected}
          />
          {label}
        </React.Fragment>
      );
    }}
    renderInput={params => {
      return (
        <TextField
          {...params}
          variant="standard"
          // placeholder={languages.schedule.allPoulesBrackets}
          label={languages.schedule.selectPoulesBrackets}
          fullWidth
          // InputLabelProps={{
          //   shrink: true
          // }}
        />
      );
    }}
    clearText=""
    closeText=""
    openText=""
    noOptionsText=""
    onOpen={() => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        var inputs = document.getElementsByTagName("input");
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].blur();
        }
      }
    }}
  />
);

export default SelectPoules;
